import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ClientState {
  currentClientId: string | null
  setCurrentClientId: (id: string | null) => void
  clear: () => void
}

export const useClientStore = create<ClientState>()(
  persist(
    (set) => ({
      currentClientId: null,
      setCurrentClientId: (currentClientId) => set({ currentClientId }),
      clear: () => set({ currentClientId: null }),
    }),
    { name: 'agent8-cdp:client' },
  ),
)
